import { createLucideIcon } from 'lucide-react';

/** Market match: a magnifier under a street light — find the closest real luminaire in the catalogue. */
const MarketMatchIcon = createLucideIcon('MarketMatchIcon', [
  ['path', { d: 'M5.5 21V8a4 4 0 0 1 4-4h2.5', key: 'pole' }],
  ['path', { d: 'M11.5 4h6.5', key: 'head' }],
  ['path', { d: 'M13 7.2l-.8 1.3M15 7.2v1.5M17 7.2l.8 1.3', strokeWidth: '1.6', key: 'rays' }],
  ['circle', { cx: '15.5', cy: '15.5', r: '3.3', key: 'lens' }],
  ['path', { d: 'm21 21-3.1-3.1', key: 'handle' }],
]);

export default MarketMatchIcon;
